import { createAction } from 'redux-act';

import * as campaigns from '../../core/campaigns';

export const fetchCampaigns = createAction(
  'get all campaigns',
);
export const fetchCampaignsSuccess = createAction(
  'get all campaigns success',
  (allCampaigns) => allCampaigns
);
export const fetchCampaignsFail = createAction(
  'get all campaigns fail',
  (error) => error
);

export const fetchCampaignDetails = createAction(
  'get campaign details',
);

export const fetchCampaignDetailsSuccess = createAction(
  'get campaign details success',
  (campaign) => campaign
);

export const fetchCampaignDetailsFail = createAction(
  'get campaign details fail',
  (error) => error
);

export const fetchCampaignsNames = createAction(
  'get campaingns names'
);

export const fetchCampaignsNamesSuccess = createAction(
  'get campaingns names success'
);

export const fetchCampaignsNamesFail = createAction(
  'get campaingns names fail'
);

export const fetchCampaignsIds = createAction(
  'get campaingns ids'
);

export const fetchCampaignsIdsSuccess = createAction(
  'get campaingns ids success'
);

export const fetchCampaignsIdsFail = createAction(
  'get campaingns ids fail'
);

export const fetchCampaignsCountries = createAction(
  'get campaingns countries success'
);

export const fetchCampaignsCountriesSuccess = createAction(
  'get campaingns countries success'
);

export const fetchCampaignsCountriesFail = createAction(
  'get campaingns countries fail'
);

export const openEditCampaign = createAction(
  'open edit campaign modal',
);
export const closeEditCampaign = createAction(
  'close edit campaign modal',
);

export const updateCampaign = createAction(
  'update campaign',
);

export const updateCampaignSuccess = createAction(
  'update campaign success',
);

export const updateCampaignFail = createAction(
  'update campaign fail',
  (error) => error
);

export const fetchCampaignsByCountry = createAction(
  'get all campaigns',
);
export const fetchCampaignsByCountrySuccess = createAction(
  'get all campaigns success',
  (allCampaigns) => allCampaigns
);
export const fetchCampaignsByCountryFail = createAction(
  'get all campaigns fail',
  (error) => error
);

export const fetchCampaignsByCategory = createAction(
  'get all campaigns',
);
export const fetchCampaignsByCategorySuccess = createAction(
  'get all campaigns success',
  (allCampaigns) => allCampaigns
);
export const fetchCampaignsByCategoryFail = createAction(
  'get all campaigns fail',
  (error) => error
);

export const reducer = {
  [fetchCampaigns]: (state, payload) =>
    campaigns.fetchCampaigns(state, payload),
  [fetchCampaignsSuccess]: (state, payload) =>
    campaigns.fetchCampaignsSuccess(state, payload),
  [fetchCampaignDetailsSuccess]: (state, payload) =>
    campaigns.fetchCampaignDetailsSuccess(state, payload),
  [fetchCampaignsNames]: (state, payload) =>
    campaigns.fetchCampaignsNames(state, payload),
  [fetchCampaignsNamesSuccess]: (state, payload) =>
    campaigns.fetchCampaignsNamesSuccess(state, payload),
  [fetchCampaignsIds]: (state, payload) =>
    campaigns.fetchCampaignsIds(state, payload),
  [fetchCampaignsIdsSuccess]: (state, payload) =>
    campaigns.fetchCampaignsIdsSuccess(state, payload),
  [fetchCampaignsCountries]: (state, payload) =>
    campaigns.fetchCampaignsCountries(state, payload),
  [fetchCampaignsCountriesSuccess]: (state, payload) =>
    campaigns.fetchCampaignsCountriesSuccess(state, payload),
  [updateCampaignSuccess]: (state, payload) =>
    campaigns.updateCampaignSuccess(state, payload),
  [fetchCampaignsByCountrySuccess]: (state, payload) =>
    campaigns.fetchCampaignsByCountrySuccess(state, payload),
  [fetchCampaignsByCategorySuccess]: (state, payload) =>
    campaigns.fetchCampaignsByCategorySuccess(state, payload),

  [openEditCampaign]: (state, payload) =>
    campaigns.openEditCampaign(state, payload),
  [closeEditCampaign]: (state, payload) =>
    campaigns.closeEditCampaign(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/campaigns.module.js
 **/